// export const ApiEndPoint = "http://127.0.0.1:8000"
// export const ApiEndPoint = "https://api.disaster-ms.woycedemo.com"
export const ApiEndPoint = process.env.REACT_APP_BACKEND_URL
// export const ApiEndPoint = "https://api.disasterms.net"
// export const ApiEndPoint = "http://127.0.0.1:8000"
// export const JitsiMeetingUrl = "localhost:8443";
export const JitsiMeetingUrl = "meet.disasterms.net";

/** Remember last voice/video choice so /meets without query still opens the right mode. */
export const MEET_MODE_SESSION_KEY = "disasterms_meet_mode";

export function persistMeetModeForNextMeet(mode) {
  try {
    const m = String(mode || "voice").toLowerCase();
    sessionStorage.setItem(MEET_MODE_SESSION_KEY, m);
  } catch (e) {
    /* ignore private mode / quota */
  }
}

export function readStoredMeetMode() {
  try {
    return sessionStorage.getItem(MEET_MODE_SESSION_KEY);
  } catch (e) {
    return null;
  }
}
